import { createWorkerFunc } from './worker';
import md5 from 'md5';

const md5Key = '123e4567-e89b-12d3-a456-426614174000';
const versionLocalStorageKey = 'media-platform-version-key';
const getVersionApi = window.location.origin + '/media/api/publisherManager/version';
// 配置信息
const config = {
    url: getVersionApi
};
let worker = undefined;

function createWorker(func) {
    const blob = new Blob([
        `(${func.toString()})();`
    ]);
    const url = window.URL.createObjectURL(blob);
    const worker = new Worker(url);
    return worker;
}

function handleRefresh() {
    window.location.reload();
};

function versionToArr(version) {
    const arr = String(version).split('.').map(str => {
        const num = parseInt(str, 10);
        // 版本号异常 返回 -1
        return isNaN(num) ? -1 : num;
    }) || [];
    return arr;
}

function handleCompareVersions(originVersion) {
    // 远程版本号为空 -- 不更新
    if (!originVersion) return false;

    // 缓存版本号为空 -- 更新
    const localVersion = localStorage.getItem(versionLocalStorageKey);
    if (!localVersion) return true;

    const oldVersionArr = versionToArr(localVersion);
    const newVersionArr = versionToArr(originVersion);

    // 远程版本号格式异常 -- 不更新
    if (newVersionArr.includes(-1) || newVersionArr.length !== 3) {
        return false;
    }

    let res = false;
    for (let i = 0; i < 3; i++) {
        // 小版本 -- 不更新
        if (i < 2 && oldVersionArr[i] !== newVersionArr[i]) {
            res = true;
        }
    }
    return res;
};

/**
 * 生成API请求的认证参数
 * 包含时间戳和MD5授权码
 */
function generateAuthParams() {
    const timestamp = Date.now();
    config.timestamp = timestamp;
    config.authorization = md5(`${md5Key}_${timestamp}`).toLowerCase();
};

function init() {
    generateAuthParams();
    worker?.postMessage({ action: 'init', config });
};

function start() {
    generateAuthParams();
    worker?.postMessage({ action: 'start', config });
};

function end() {
    worker?.postMessage({ action: 'end', config });
};

function handlePageVisibilityChange() {
    if (document.hidden) {
        end();
    } else {
        start();
    }
};

export const checkVersion = () => {
    worker = createWorker(createWorkerFunc);
    worker.onmessage = (event) => {
        if (!event?.data) return;

        const { type, data } = event.data;

        if (type === 'success') {
            const {version, action} = data;
            if (action === 'init') {
                // 只更新本地版本号 不刷新
                localStorage.setItem(versionLocalStorageKey, version);
                return;
            }
            // 手动关闭轮询机制
            if (version === 'close') {
                destroyCheckVersion();
                return;
            }
            const isRefresh = handleCompareVersions(version);
            localStorage.setItem(versionLocalStorageKey, version);
            if (isRefresh) {
                handleRefresh();
            }
        }
    };
    document.addEventListener('visibilitychange', handlePageVisibilityChange);
    init();
    start();
};

export const destroyCheckVersion = () => {
    end();
    document.removeEventListener('visibilitychange', handlePageVisibilityChange);
    worker?.terminate();
    worker = undefined;
};

const mixin = {
    mounted() {
        checkVersion();
    },
    beforeDestroy() {
        destroyCheckVersion();
    }
};

export default mixin;